import { CircularProgress, List, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { OverallComment, QuestionComment, QuestionGroup, QuestionnaireComments, SectionGroup } from '../../../models/QuestionnaireComments'
import { fetchCommentsForStartup } from '../../../networking/network'
import { useAppSelector } from '../../../store/hooks'

interface Props {

}

const UserCommentsListView = (props: Props) => {
  const { id } = useParams()
  const accessToken = useAppSelector(state => state.user.token)
  const [loading, setLoading] = useState(true)
  const [comments, setComments] = useState<QuestionnaireComments | undefined>(undefined)

  useEffect(() => {
    if (!accessToken || !id) {
      return
    }

    const fetchComments = async () => {
      const results = await fetchCommentsForStartup(accessToken, id)
      const filteredResults: QuestionnaireComments = {
        overall_comments: results.overall_comments,
        sections: []
      }
      results.sections.forEach((section: SectionGroup) => {
        let shouldInclude = false
        for (let i = 0; i < section.questions.length; ++i) {
          const questionGroup = section.questions[i]
          if (questionGroup.comments.length > 0) {
            shouldInclude = true
            break
          }
        }
        if (shouldInclude === true) {
          filteredResults.sections.push(section)
        }
      })
      setComments(filteredResults)
      setLoading(false)
    }

    fetchComments()
  }, [])

  return (
    <Box sx={{
      width: '100%'
    }}>
      {loading &&
        <Box display='flex' flexDirection='row' alignItems='center' justifyContent='space-around'>
          <CircularProgress />
        </Box>
      }
      {!loading &&
      <Box sx={{
        marginLeft: '8px',
        marginTop: '16px'
      }}>
        <Box sx={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '16px'
        }}>
          <Typography variant='h6' color='black'>
            Overall Comments
          </Typography>
          <List 
            sx={{
              width: '100%'
            }}
          >
            {comments?.overall_comments.map((overallComment: OverallComment) => {
              if (overallComment.comment.length === 0) {
                return (<></>)
              }
              return (
                <Box key={overallComment.email} display='flex' flexDirection='column'
                sx={{
                  background: '#E4E6F380',
                  padding: '12px',
                  borderRadius: '16px',
                  marginTop: '12px'
                }}>
                  <Typography variant='body1'>
                    {overallComment.comment}
                  </Typography>
                  <Typography sx={{
                    marginTop: '6px'
                  }} variant='caption'>
                    {overallComment.email}
                  </Typography>
                </Box>
              )
            })}
            </List>
          </Box>
          {comments?.sections.map((section: SectionGroup) => {
            return (
              <Box sx={{
                backgroundColor: 'white',
                borderRadius: '16px',
                padding: '16px',
                marginTop: '16px'
              }}>
                <Typography variant='h6' color='black' sx={{
                  marginTop: '12px'
                }}>
                  {section.display_text}
                </Typography>
                <List sx={{
                  width: '100%'
                }}>
                {section.questions.map((question: QuestionGroup) => {
                  if (question.comments.length === 0) {
                    return (<></>)
                  }
                  
                  return (
                    <Box key={question.display_text} sx={{
                      marginTop: '12px'
                    }}>
                      <Box>
                        <Typography variant='body1' sx={{
                          fontSize: '18px',
                          fontWeight: 'bold'
                        }}>{question.display_text}</Typography>
                      </Box>
                      {question.comments.length === 0 &&
                        <Typography variant='body2' sx={{
                          marginTop: '12px',
                          fontStyle: 'italic'
                        }}>
                          No comments
                        </Typography>
                      }
                      {question.comments.map((comment: QuestionComment) => {
                        return (
                          <Box sx={{
                            background: '#E4E6F380',
                            padding: '12px',
                            borderRadius: '16px',
                            marginTop: '12px'
                          }}>
                            <Typography variant='body1'>
                              {comment.comment}
                            </Typography>
                            <Typography variant='caption'>
                              {comment.email}
                            </Typography>
                          </Box>
                        )
                      })

                      }
                    </Box>
                  )
                })}

              </List>
            </Box>
            )
          })

          }
        </Box>
      }
    </Box>
  )
}

export default UserCommentsListView
